import Swal from "sweetalert2";

const CustomAlert = {};

CustomAlert.install = (Vue) => {
  const vue = Vue;
  vue.prototype.$alert = {
    warningAlert(text) {
      Swal.fire({
        text,
        icon: "warning",
        confirmButtonText: "ok",
        confirmButtonColor: "#185abc",
      });
    },
    errorAlert(text) {
      Swal.fire({
        text,
        icon: "error",
        confirmButtonText: "ok",
        confirmButtonColor: "#185abc",
      });
    },
  };
};

export default CustomAlert;
